import moment from 'moment'
import React, { useState, useEffect,useRef } from 'react'
import { Attendance,FR } from '../../sdk'
import { Loader } from '../Default'
import { assetUrl } from '../../helpers'
import { DataTable2 } from '../Default/DataTables/DataTable2'
import { useAuthContext } from '../../context/Auth/Create'

export const DateWiseSearch = () => {
  const userAuth=useAuthContext()
  const [state, setState] = useState({ loader: true, date: moment().subtract(1,"day").format("yyyy-MM-DD"), data: [], tableLoader: true ,
    tbHeader:[
      {title:"Date",name:"date",data:"date"},{title:"ID",name:"employeeId",data:"employeeId"},{title:"Name",name:"employeeName",data:"employeeName"},{title:"Company Name",data:"employeeId",render:function(data,type,row){
        return row.companyName?row.companyName:"N/A"
      }},{title:"Department",name:"department",data:"department"},{title:"CheckIn",data:"employeeId",render:function(data,type,row){
        return row.checkInTime?row.checkInTime:""
      }},{title:"CheckOut",data:"employeeId",render:function(data,type,row){
        return row.checkOutTime?row.checkOutTime:""
      }},{title:"Required Hours",data:"employeeId",render:function(data,type,row){
        return convertHoursToHHMM(row.totalRequiredHours);
      
      }},{title:"Worked Hour",data:"employeeId",render:function(data,type,row){
        return convertHoursToHHMM(row.workedHours)
      }},{title:"Excess/ShortTime",data:"employeeId",render:function(data,type,val){
        return val.totalRequiredHours > val.workedHours?`-${val.shortExactTime}`:val.shortExactTime
      }},{title:"details",data:"employeeId",render:function(data,type,row){
      return `<button type="button" data-emloyeeId=${data} class="btn btn-theme details">Details</button>`
    }}],
    tbHeader2:[{title:"ID",name:"employeeId",data:"employeeId"},{title:"Name",name:"employeeName",data:"employeeName"},{title:"Date",name:"date",data:"date"},{title:"CheckIn",data:"employeeId",render:function(data,type,row){
      return row.checkIn?row.checkIn:""
    }},{title:"CheckOut",name:"CheckOut",data:"employeeId",render:function(data,type,row){
      return row.checkOut?row.checkOut:""
    }},{title:"cameraId",name:"cameraId",data:"employeeId",render:function(data,type,row){
      return row.cameraId?row.cameraId:""
    }},{title:"Image",data:"employeeId", render: function (data, type, row) {
      return row.imageName && row.imageName !=""?`<a href=${assetUrl}${row.imageName} target='_blank'><img src=${assetUrl}${row.imageName} style="width:100%"; /></a>`:"mannual attendnce";
    },}],
  data:[],data2:[],tableLoader2:true,companyName:userAuth.user.isHightAuthority?userAuth?.user.companyName:"",
  department:"",
  companies:[],
  departments:[],});

  const ref4=useRef({
    employeeId:"",
    date:moment().subtract(1,"day").format("yyyy-MM-DD"),
    companyName:userAuth.user.isHightAuthority?userAuth?.user.companyName:"",
    department:"",
    companies:[],
    departments:[],
    dataTable1Params:{
      draw:1,
      start:0,
      length:0,
      search:"",
      order:"",
      columns:"",
      sort:"asc"
    },
    dataTable2Params:{
      draw:1,
      start:0,
      length:0,
      search:"",
      order:"",
      columns:"",
      sort:"asc"
    }

  });
  
  function convertHoursToHHMM(seconds) {
    const duration = moment.duration(seconds, 'seconds');
      const formattedTime = `${Math.floor(duration.asHours()).toString().padStart(2, '0')}:${duration.minutes().toString().padStart(2, '0')}:${duration.seconds().toString().padStart(2, '0')}`;
      return formattedTime;
    }
    const apiDataWithPagination = async (data,callBack2,date=ref4.current.date,companyName=ref4.current.companyName,department=ref4.current.department) => {
      try {
       
        ref4.current={...ref4.current,dataTable2Params:{
          draw:data?.draw,
          start:data?.start,
          length:data?.length,
          search:data?.search?.value || "",
          order:data?.order,
          columns:data?.columns,
          sort:data?.sort
        },
        callBack2
        }
          
        let apiData = {
          type:"Employee",
          draw:data?.draw,
          start:data?.start,
          length:data?.length,
          search:data?.search?.value || "",
          order:data?.order,
          columns:data?.columns,
          sort:data?.sort,
          date:date,
          companyName,department
          
                
        }
        let users=await  new Attendance().dayWiseDataWithPagination({...apiData});
        ref4.current.callBack2(users);
        setState((pre)=>{
          return {...pre,tableLoader: false}
          })
     
      } catch (e) {
        alert("error occur")
      }
  
    }
  
  const apiData2WithPagination = async (data,callBack,employeeId=ref4.current.employeeId) => {
      try {
         setState((pre)=>{
          return {...pre,tableLoader2:true}
         })
        ref4.current={...ref4.current,employeeId,dataTable1Params:{
          draw:data?.draw,
          start:data?.start,
          length:data?.length,
          search:data?.search?.value || "",
          order:data?.order,
          columns:data?.columns,
          sort:data?.sort
        },
        callBack
        }
          
        let apiData = {
          type:"Employee",
          draw:data?.draw,
          start:data?.start,
          length:data?.length,
          search:data?.search?.value || "",
          order:data?.order,
          columns:data?.columns,
          sort:data?.sort,
          date:ref4.current.date,
          employeeId:String(employeeId)
                
        }
        if(employeeId ===""){
        return ;
        }
        let users=await new FR().employeeAttendanceDetailsWithpagination({...apiData});
        ref4.current.callBack(users);
        setState((pre)=>{
          return {...pre,tableLoader2:false}
         })
      } catch (e) {
        console.log(e)
        alert("error occur")
      }
  
  }
  const apiData=async()=>{
    try{
    let users=await new FR().getCompanies();
    let departments=[]
		let find=users.find(val=>val.companyName===state.companyName);
			if(find){
			 departments=find.departments;
			}
		
		setState((pre)=>{
		  return {...pre,companies:users,loader:false,departments}
	   })
   }catch(e){
    console.log(e)
    alert("error occur")
    }

}
 
    const onHandler = (event) => {
      let date = moment(event.target.value).format("yyyy-MM-DD");
      ref4.current.date=date;
      ref4.current.employeeId="";
      setState((pre)=>{
        return {...pre,date:date}
          })
        
        
      }

      const onDetails=(employeeId)=>{
        apiData2WithPagination({...ref4.current,draw:ref4.current.dataTable1Params.draw,length:10,start:0,search:""},ref4.current.callBack,employeeId)
        window.$("#showImg").modal("show");
          // setState((pre)=>{
          //   return {...pre,employeeId}
          // })
         
         
        }
        const onHandlerType=(event)=>{
          let key=event.target.name;
          let value=event.target.value;
          if(key==="companyName"){
          let departments=[];
          let find=state.companies.find(val=>val.companyName===value);
          if(find){
           departments=find.departments;
          }
          ref4.current={...ref4.current,[key]:value,department:""}
          setState((pre)=>{
            return{...pre,departments,department:""}
          })
          }
          else{
           ref4.current={...ref4.current,[key]:value}
           setState((pre)=>{
             return{...pre,[key]:value}
           })
          }
         }
        useEffect(()=>{
          apiData();
          },[])
  if (!state.loader) {
    return (
      <>
        <div className="card mb-3">
          {/* BEGIN card-body */}
          <div className="card-body">
            <div className="d-flex fw-bold small mb-3 row" style={{textAlign:"center"}}>
              
              <div className="col-12">
                <span className="flex-grow-1">Employees FR Daily Report</span>
              </div>
              <div className="col-2"></div>
              <div className="col-sm-12 col-md-3 col-lg-2">
      <div class="form-group mb-3" >
        <label class="form-label text-white fw-bold" for="exampleFormControlSelect1" ></label>
        <select class="form-select" name="companyName" id="exampleFormControlSelect1" onChange={onHandlerType} style={{color:"rgb(60, 210, 165)"}}>
          <option value="" selected={ref4.current.companyName===""}>Company</option>
          {state.companies.map((val,index)=>{
            return  <option key={index} value={val.companyName} selected={ref4.current.companyName===val.companyName}>{val.companyName}</option>
          })}
         
          
          </select>
          </div>
       </div>
       <div className="col-sm-12 col-md-3 col-lg-2">
      <div class="form-group mb-3" >
        <label class="form-label text-white fw-bold" for="exampleFormControlSelect2" ></label>
        <select class="form-select" name="department" id="exampleFormControlSelect2" onChange={onHandlerType} style={{color:"rgb(60, 210, 165)"}}>
        <option value="" selected={ref4.current.companyName===""}>Department</option>
          {state.departments.map((val,index)=>{
            return  <option key={index} value={val} selected={ref4.current.department===val}>{val}</option>
          })}
          </select>
          </div>
       </div>
              <div className="col-2">
                {/* <button type="button" class="btn btn-theme" onClick={exportCsv}>Export Csv</button> */}
                <div class="form-group mb-3" >
                  <label class="form-label" for="exampleFormControlSelect1"></label>
                  <input type="date" class="form-control" id='date' name='date' placeholder="dd/mm/yyyy" onChange={onHandler} value={state.date} style={{color:"rgb(60, 210, 165)"}}/>
                </div>
              </div>
             
              <div className='col-1'>
                <label class="form-label" for="Location"></label>
                <br />
                <button type="button" class="btn btn-theme" onClick={()=>apiDataWithPagination({...ref4.current.dataTable2Params},ref4.current.callBack2)}>Search</button>
              </div>
            </div>

            {state.tableLoader && <><Loader/></>}
   
   <div className="col-12">
   {<DataTable2 headers={state.tbHeader} image={true}  reverse={true} count={"paginationTable4"} ajax={apiDataWithPagination} onDetails={onDetails} isLoading={state.dataTableLoader}/>}
  
   </div>
          </div>
          <div className="card-arrow">
            <div className="card-arrow-top-left" />
            <div className="card-arrow-top-right" />
            <div className="card-arrow-bottom-left" />
            <div className="card-arrow-bottom-right" />
          </div>
        </div>
        <div class="modal" id="showImg">
          <div class="modal-dialog modal-xl">
            <div class="modal-content">
            <div class="modal-header">
        
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
  
              <div class="modal-body">
              {state.tableLoader2 && <Loader/>}
              {<DataTable2 headers={state.tbHeader2} data={state.data2} image={true}  reverse={true} count={"paginationTable5"} ajax={apiData2WithPagination} />}
              </div>

            </div>
          </div>
        </div>


      </>


    )
  }
  else {

    return (<>
      <Loader />
    </>)
  }

}
